import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot } from '@angular/router';
import { ApplicationActions } from '../actions/application.actions';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class SubmitAcatsCanActivate implements CanActivate {
  constructor(
    appActions: ApplicationActions,
    flowManager: FlowManagerService,
    router: Router) {
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.router = router;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const requestId = this.appActions.getData('Acats.acatsRequestId');
    if (requestId != null && requestId !== '') {
      return true;
    } else {
      return false;
    }
  }
}
